import { createSelector } from "redux-starter-kit";

export default createSelector(
  ["factoring.updateFactoringProfileLoading"],
  loading => loading
);
